module.exports = __webpack_public_path__ + "VOLKSWAGEN-logo.png";